<template>
    <Card
        v-if="isLayoutCard && product"
        :analyticProducts="analyticProducts"
        :product="product"
        :class="[...bordersVanishClasses]"
    />
    <Plank
        v-else-if="isLayoutPlank && product"
        :product="product"
        :analyticProducts="analyticProducts"
        :allowAddToFavorites="allowAddToFavorites"
        @count-decrease="$emit('count-decrease', product.id)"
        @count-increase="$emit('count-increase', product.id)"
    />
    <PlankCart
        v-else-if="isLayoutPlankCart && product"
        :product="product"
        :analyticProducts="analyticProducts"
        @count-decrease="$emit('count-decrease', product.id)"
        @count-increase="$emit('count-increase', product.id)"
        @set-service="$emit('set-service', $event)"
        @remove-extension="$emit('remove-extension', $event)"
    />
    <PlankShowcase v-else-if="isLayoutPlankShowcase && product" :isInTightList="isInTightList" :product="product" />

    <SkeletonCard v-else-if="isLayoutCard" :class="[...bordersVanishClasses]" />
    <SkeletonPlank v-else-if="isLayoutPlank" />
    <SkeletonPlankCart v-else-if="isLayoutPlankCart" />
    <SkeletonPlankShowcase :isInTightList="isInTightList" v-else-if="isLayoutPlankShowcase" />
</template>

<script>
import { layoutsTypes, defaultLayoutType } from './types';
import VueTypes, { object, nullable } from 'vue-types';
import Card from './components/Card';

export default {
    name: 'ProductAgent',
    props: {
        product: VueTypes.oneOfType([
            VueTypes.object, // Объект, если данные о продукте существуют
            VueTypes.null
        ]).isRequired,
        analyticProducts: VueTypes.any,
        layoutType: VueTypes.oneOf(layoutsTypes).def(defaultLayoutType),
        isInTightList: VueTypes.bool.def(false),
        allowAddToFavorites: VueTypes.bool.def(true),
        borderSidesToVanish: VueTypes.array.def([]) // TO DO: write a custom condition
    },
    computed: {
        isLayoutCard() {
            return this.layoutType === 'card' ? true : false;
        },
        isLayoutPlank() {
            return this.layoutType === 'plank' ? true : false;
        },
        isLayoutPlankCart() {
            return this.layoutType === 'plank-cart' ? true : false;
        },
        isLayoutPlankShowcase() {
            return this.layoutType === 'plank-showcase' ? true : false;
        },

        bordersVanishClasses() {
            const handledClasses =
                this.borderSidesToVanish.map(side => {
                    return `--border-${side}-hide`;
                }) || [];

            return handledClasses;
        }
    },
    components: {
        Card,
        Plank: () => import('./components/Plank'),
        PlankCart: () => import('./components/PlankCart'),
        PlankShowcase: () => import('./components/PlankShowcase'),

        SkeletonCard: () => import('./components/Card/skeleton'),
        SkeletonPlank: () => import('./components/Plank/skeleton'),
        SkeletonPlankCart: () => import('./components/PlankCart/skeleton'),
        SkeletonPlankShowcase: () => import('./components/PlankShowcase/skeleton')
    }
};
</script>

<style lang="scss">
@import './styles/context.scss';
@import './styles';
</style>
